export default "__VITE_ASSET__4NiLElRR__"